import ParentDashboardTypes from './parentDashboard.types';

export const addChildDetails = (obj) => ({
	type: ParentDashboardTypes.ADD_CHILD_DETAILS.PENDING,
	payload: obj,
});

export const setEditChildDetails = (obj) => ({
	type: ParentDashboardTypes.SET_EDIT_CHILD_DETAILS,
	payload: obj,
});

export const editChild = (obj) => ({
	type: ParentDashboardTypes.EDIT_CHILD_DETAILS.PENDING,
	payload: obj,
});

export const getChildToken = (val) => ({
	type: ParentDashboardTypes.GET_CHILD_TOKEN.PENDING,
	payload: val,
});

export const fetchChildrenList = () => ({
	type: ParentDashboardTypes.GET_CHILDREN_LIST.PENDING,
});

export const updateParentName = (val) => ({
	type: ParentDashboardTypes.UPDATE_PARENT_NAME.PENDING,
	payload: val,
});

export const setShowAddChild = (val) => ({
	type: ParentDashboardTypes.SHOW_ADD_CHILD,
	payload: val,
});

export const setActiveChild = (val) => ({
	type: ParentDashboardTypes.SET_ACTIVE_CHILD,
	payload: val,
});

export const setShowEditChild = (val) => ({
	type: ParentDashboardTypes.SHOW_EDIT_CHILD,
	payload: val,
});

export const getChildCourse = (val) => ({
	type: ParentDashboardTypes.GET_CHILD_COURSE.PENDING,
	payload: val,
});

export const getChildSpeechCourse = (val) => ({
	type: ParentDashboardTypes.GET_CHILD_SPEECH_COURSE.PENDING,
	payload: val,
});

export const getProductDetails = (val) => ({
	type: ParentDashboardTypes.GET_PRODUCT_DETAILS_CHILD.PENDING,
	payload: val,
});

export const resetToken = () => ({
	type: ParentDashboardTypes.RESET_TOKEN,
});

export const applyLicense = () => ({
	type: ParentDashboardTypes.APPLY_LICENSE.PENDING,
});

export const getChildReport = (val = false) => ({
	type: ParentDashboardTypes.GENERATE_CHILD_REPORT.PENDING,
	payload: val,
});

export const getChildDetails = () => ({
	type: ParentDashboardTypes.GET_CHILD_DETAILS.PENDING,
});
